import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import { UnmountClosed } from 'react-collapse';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import {
  getControlClass,
  getControlDocumentation,
  getControlEfficiency,
  getControlState,
  getControlType,
  getFrequency,
} from '../../tools/totalEnergiesRiskControlTools';
import TotalEnergiesRiskControlExpandedContainer from './TotalEnergiesRiskControlExpandedContainer';

export default function ControlDefault({ elementID }) {
  const dispatch = useDispatch();
  const controlLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );
  const controlExpandedID = useSelector(
    (s) => s.currentPage?.controlExpandedID
  );
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (
      controlLevel1 &&
      controlExpandedID &&
      controlLevel1?.id === controlExpandedID
    ) {
      setIsOpened(true);
      dispatch(currentPageAction.change('controlExpandedID', undefined));
    }
  }, [controlLevel1, controlExpandedID]);

  if (!controlLevel1) {
    return (
      <LoaderContainer key={elementID} className="mb-1">
        <div className="card default">
          <div className="card-body" />
        </div>
      </LoaderContainer>
    );
  }

  return (
    <Container
      key={elementID}
      $bgColor={
        controlLevel1?.active
          ? colors?.totalEnergiesRiskControlState[controlLevel1?.state]
          : colors?.danger
      }
      className="mb-1"
    >
      <AppCard bodyClassName="p-0 default" headerClassName="p-0">
        <div className="default-content">
          <div className="content">
            <div
              className="state"
              title={
                controlLevel1?.active
                  ? getControlState(controlLevel1?.state)
                  : 'Desactivado'
              }
            >
              {!controlLevel1?.active && (
                <AppRemixIcon
                  icon="delete-bin"
                  color="#fff"
                  size={20}
                />
              )}
            </div>
            <div className="content-col">
              <div className="text-primary header container-header mb-2">
                {controlLevel1?.active
                  ? getControlState(controlLevel1?.state)
                  : 'Desactivado'}
                <div>{controlLevel1?.code}</div>
              </div>
              <div className="text-primary header container-header">
                Nombre:
              </div>
              <div>{controlLevel1?.name || '-'}</div>
              <div className="text-primary header container-header">
                Descripción:
              </div>
              <div>{controlLevel1?.description || '-'}</div>
            </div>
            <div className="content-col">
              <div className="text-primary header container-header">
                Tipo de control:
              </div>
              <div>{getControlType(controlLevel1?.controlType)}</div>
              <div className="text-primary header">Clase de control</div>
              <div>{getControlClass(controlLevel1?.controlClass)}</div>
              <div className="text-primary header">
                Documentación del control
              </div>
              <div>
                {getControlDocumentation(controlLevel1?.controlDocumentation)}
              </div>
            </div>
            <div className="content-col third-col">
              <div className="column">
                <div className="text-primary header">
                  Efectividad del control:
                </div>
                <div>
                  {getControlEfficiency(controlLevel1?.controlEfficiency)}
                </div>
                <div className="text-primary header">Frecuencia:</div>
                <div>{getFrequency(controlLevel1?.frequency)}</div>
              </div>
              <div className="column">
                <div className="text-primary header">Responsable:</div>
                <div>{controlLevel1?.responsibleName || '--'}</div>
                <div className="text-primary header">
                  Fecha prevista revisión:
                </div>
                <div>{controlLevel1?.scheduledReviewDate || '--'}</div>
              </div>
            </div>
          </div>
          <div
            className="expand pointer"
            onClick={() => setIsOpened(!isOpened)}
          >
            <AppRemixIcon icon={isOpened ? 'subtract' : 'add'} color="white" />
          </div>
        </div>
      </AppCard>
      <UnmountClosed isOpened={isOpened}>
        <TotalEnergiesRiskControlExpandedContainer elementID={elementID} />
      </UnmountClosed>
    </Container>
  );
}

const LoaderContainer = styled.div`
  & > .card {
    height: 126px;
  }
`;

const Container = styled.div`
  & > .card {
    height: 126px;
    border-radius: 5px;
    border: 1px solid;
  }

  .default-content {
    display: grid;
    grid-template-columns: 1fr 40px;

    .content {
      display: grid;
      grid-template-columns: 40px 1fr 1fr 1fr;

      .state {
        background-color: ${(props) => props?.$bgColor};
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .content-col {
        border-right: 1px solid #ccc;
        padding: 6px;
        overflow-y: auto;
        height: 124px;
        font-size: 12px;

        .container-header {
          display: flex;
          flex: auto;
          justify-content: space-between;
        }

        .header {
          font-weight: bold;
        }

        &.third-col {
          display: flex;
          justify-content: space-around;
          align-items: center;

          .column {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
    }
    & > .expand {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 2px;
      font-size: 20px;
      height: 120px;
      margin: 2px;
      background-color: ${colors.primary};
    }
  }
`;
